export class ClientModel {
    static COLLECTION_NAME = 'client'

    _id?: string
    accelationDevice?: object
    address1?: string
    address2?: string
    case?: any
    clientNumber?: any
    clinic?: string
    cordinator?: string
    doctor?: string
    email1?: string
    email2?: string
    enableAlignerMail?: boolean
    familyName?: string
    familyNameKana?: string
    firstName?: string
    firstNameKana?: string
    gender?: boolean
    useTreatmentMenu?: boolean
    phone1?: string
    phone2?: string
    presentationName?: string
    publicationApproved?: boolean
    relatedUrls?: string[]
    searchName?: string
    searchNameKana?: string
    searchPhone1?: string
    searchPhone2?: string
    birthday?: any
    lastDate?: string
    startDate?: any
    accountDate?: any
}

export function getFullName(client) {
    return `${ client.familyName } ${ client.firstName }`
}



// WEBPACK FOOTER //
// ./src/models/client.model.ts